(() => {
  const drawer = document.querySelector('[data-chikas-cart-drawer]');
  if (!drawer) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIM_MS = reduceMotion ? 0 : 480;
  const moneyFormat =
    (window.Shopify && window.Shopify.money_format) ||
    (window.theme && window.theme.moneyFormat) ||
    '${{amount}}';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  let closingTimer = null;
  let toastTimer = null;
  let statusTimer = null;
  let pumping = false;
  let refreshQueued = false;
  let clearQueued = false;
  const desiredByVariant = new Map();
  const pendingAdds = new Map();

  const formatMoney = (cents) => {
    try {
      if (typeof window.ChikasMoney === 'function') return window.ChikasMoney(cents);
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (_) {
      /* fall through */
    }
    return (Number(cents) / 100).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    });
  };

  const escapeHtml = (str) =>
    String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const imageUrl = (src, size) => {
    if (!src) return '';
    try {
      const url = src.startsWith('//') ? `https:${src}` : src;
      if (url.includes('cdn.shopify.com') && !url.includes(`_${size}x.`)) {
        return url.replace(/(\.\w+)(\?|$)/, `_${size}x$1$2`);
      }
      return url;
    } catch (_) {
      return src;
    }
  };

  const compareCache = {};
  const compareKnown = {};

  const discountTitle = (item) => {
    const titles = [];
    (item.line_level_discount_allocations || []).forEach((a) => {
      const t = a && a.discount_application && a.discount_application.title;
      if (t && !titles.includes(t)) titles.push(t);
    });
    (item.discounts || []).forEach((d) => {
      if (d && d.title && !titles.includes(d.title)) titles.push(d.title);
    });
    return titles.join(' + ');
  };

  const refCents = (item) =>
    Math.max(Number(item.original_price) || 0, Number(compareKnown[item.variant_id]) || 0);

  const syncLineDiscount = (row) => {
    if (!row) return;
    const qty = Number(row.querySelector('[data-chikas-qty]')?.value || 0);
    const unit = Number(row.dataset.unitCents || 0);
    const ref = Number(row.dataset.refCents || 0);
    const was = row.querySelector('.cart-item__was');
    const pill = row.querySelector('[data-chikas-line-discount]');
    const onSale = ref > unit && unit > 0 && qty > 0;
    row.classList.toggle('has-discount', onSale);
    if (was) {
      was.hidden = !onSale;
      was.textContent = onSale ? formatMoney(ref * qty) : '';
    }
    if (!pill) return;
    if (!onSale) {
      pill.hidden = true;
      pill.innerHTML = '';
      return;
    }
    const pct = Math.round(((ref - unit) / ref) * 100);
    const title = row.dataset.discountTitle || '';
    pill.innerHTML =
      `<span class="cart-item__discount-tag">-${pct}%</span>` +
      `<span class="cart-item__discount-text">${title ? `Descuento ${escapeHtml(title)}` : 'Descuento aplicado'}` +
      ` · Ahorras ${escapeHtml(formatMoney((ref - unit) * qty))}</span>`;
    pill.hidden = false;
  };

  const syncSavings = () => {
    const el = drawer.querySelector('[data-chikas-cart-savings]');
    if (!el) return;
    let saved = 0;
    drawer.querySelectorAll('.cart-item').forEach((row) => {
      const qty = Number(row.querySelector('[data-chikas-qty]')?.value || 0);
      const unit = Number(row.dataset.unitCents || 0);
      const ref = Number(row.dataset.refCents || 0);
      if (ref > unit && unit > 0) saved += (ref - unit) * qty;
    });
    el.hidden = saved <= 0;
    el.innerHTML = saved > 0 ? `Estás ahorrando <strong>${escapeHtml(formatMoney(saved))}</strong>` : '';
  };

  const syncAllDiscounts = () => {
    drawer.querySelectorAll('.cart-item').forEach(syncLineDiscount);
    syncSavings();
  };

  const loadCompare = (item) => {
    if (!item || !item.handle || !item.variant_id) return;
    if (!compareCache[item.handle]) {
      compareCache[item.handle] = fetch(`${root}products/${encodeURIComponent(item.handle)}.js`, {
        credentials: 'same-origin',
      })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    }
    compareCache[item.handle].then((product) => {
      if (!product) return;
      (product.variants || []).forEach((v) => {
        compareKnown[v.id] = Number(v.compare_at_price) || 0;
      });
      const row = drawer.querySelector(`.cart-item[data-key="${escKey(item.key)}"]`);
      if (!row) return;
      const ref = refCents(item);
      if (ref !== Number(row.dataset.refCents || 0)) {
        row.dataset.refCents = String(ref);
        syncLineDiscount(row);
        syncSavings();
      }
    });
  };

  const setLoading = () => {
    /* Sin overlay/shimmer: las actualizaciones son silenciosas */
  };

  const escKey = (key) =>
    window.CSS && typeof CSS.escape === 'function'
      ? CSS.escape(key)
      : String(key).replace(/"/g, '\\"');

  const setCount = (n, opts = {}) => {
    const count = Number(n) || 0;
    const pulse = opts.pulse !== false;
    document.querySelectorAll('[data-chikas-cart-count]').forEach((el) => {
      el.textContent = String(count);
      if (!pulse) return;
      el.classList.remove('is-pulse');
      void el.offsetWidth;
      if (count > 0) el.classList.add('is-pulse');
    });

    const pill = drawer.querySelector('[data-chikas-cart-pill]');
    if (pill) {
      pill.hidden = count === 0;
      const num = pill.querySelector('[data-chikas-cart-count-label]');
      const unit = pill.querySelector('[data-chikas-cart-unit]');
      if (num) num.textContent = String(count);
      if (unit) unit.textContent = count === 1 ? 'prenda' : 'prendas';
      if (pulse) {
        pill.classList.remove('is-updated');
        void pill.offsetWidth;
        if (count > 0) pill.classList.add('is-updated');
      }
    }

    document.querySelectorAll('[data-chikas-cart-open]').forEach((el) => {
      if (el.classList.contains('chikas-header__bag')) {
        el.setAttribute('aria-label', `Bolsa (${count})`);
      }
    });
  };

  const pulseBag = () => {
    document.querySelectorAll('.chikas-header__bag').forEach((bag) => {
      bag.classList.remove('is-adding');
      void bag.offsetWidth;
      bag.classList.add('is-adding');
      window.setTimeout(() => bag.classList.remove('is-adding'), 600);
    });
  };

  const showStatus = (text) => {
    const bar = drawer.querySelector('[data-chikas-cart-status]');
    const label = drawer.querySelector('[data-chikas-cart-status-text]');
    if (!bar || !label) return;
    label.textContent = text || 'Añadido a tu bolsa';
    bar.classList.add('is-visible');
    window.clearTimeout(statusTimer);
    statusTimer = window.setTimeout(() => bar.classList.remove('is-visible'), 2600);
  };

  const hideToast = () => {
    const toast = document.querySelector('[data-chikas-cart-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.setTimeout(() => {
      toast.hidden = true;
    }, 400);
  };

  const showToast = (item) => {
    const toast = document.querySelector('[data-chikas-cart-toast]');
    if (!toast || !item) return;
    const title = toast.querySelector('[data-chikas-toast-title]');
    const thumb = toast.querySelector('[data-chikas-toast-thumb]');
    if (title) title.textContent = item.product_title || item.title || 'Producto';
    if (thumb) {
      if (item.image) {
        thumb.src = imageUrl(item.image, 120);
        thumb.hidden = false;
      } else {
        thumb.hidden = true;
        thumb.removeAttribute('src');
      }
    }
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, 3200);
  };

  const open = () => {
    window.clearTimeout(closingTimer);
    drawer.classList.remove('is-closing');
    if (!drawer.open) {
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
    }
    document.documentElement.classList.add('chikas-drawer-open');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
  };

  const close = () => {
    hideToast();
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    document.documentElement.classList.remove('chikas-drawer-open');
    window.clearTimeout(closingTimer);
    closingTimer = window.setTimeout(() => {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.removeAttribute('open');
      drawer.classList.remove('is-closing');
    }, ANIM_MS);
  };

  const emptyHtml = () => `
    <div class="chikas-drawer__empty" data-chikas-cart-empty>
      <div class="chikas-drawer__empty-icon" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>
      </div>
      <p class="drawer-note">Tu bolsa está vacía.</p>
      <p class="drawer-note-sub">Descubre siluetas que te abrazan y encuentra tu próximo favorito.</p>
      <button type="button" class="btn full" data-chikas-cart-close>SEGUIR COMPRANDO</button>
    </div>`;

  const itemHtml = (item, highlightKey, notice) => {
    const img = item.image
      ? `<a class="cart-item__media" href="${escapeHtml(item.url)}"><img src="${escapeHtml(imageUrl(item.image, 240))}" alt="" width="88" height="118" loading="lazy"></a>`
      : '';
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item__meta">${escapeHtml(item.variant_title)}</p>`
        : '';
    const sku = item.sku ? `<p class="cart-item__meta">Ref. ${escapeHtml(item.sku)}</p>` : '';
    const justAdded = highlightKey && item.key === highlightKey ? ' is-just-added' : '';
    const noticeHtml = notice
      ? `<p class="cart-item__notice" role="status">${escapeHtml(notice)}</p>`
      : '';
    return `
      <div class="cart-item${justAdded}" data-key="${escapeHtml(item.key)}" data-unit-cents="${item.final_price || 0}" data-ref-cents="${refCents(item)}" data-discount-title="${escapeHtml(discountTitle(item))}">
        ${img}
        <div class="cart-item__info">
          <div class="cart-item__top">
            <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
            <button type="button" class="cart-item__remove" data-chikas-cart-remove="${escapeHtml(item.key)}" aria-label="Quitar">✕</button>
          </div>
          ${variant}${sku}
          <div class="cart-item__bottom">
            <div class="quantity quantity--stepper">
              <button type="button" data-chikas-qty-minus aria-label="Menos">−</button>
              <input type="number" value="${item.quantity}" min="0" data-chikas-qty data-key="${escapeHtml(item.key)}" aria-label="Cantidad">
              <button type="button" data-chikas-qty-plus aria-label="Más">+</button>
            </div>
            <div class="cart-item__prices">
              <s class="cart-item__was" hidden></s>
              <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
            </div>
          </div>
          <p class="cart-item__discount" data-chikas-line-discount hidden></p>
          ${noticeHtml}
        </div>
      </div>`;
  };

  const setLineNotice = (row, notice) => {
    if (!row) return;
    const info = row.querySelector('.cart-item__info') || row;
    let noticeEl = row.querySelector('.cart-item__notice');
    if (notice) {
      if (!noticeEl) {
        noticeEl = document.createElement('p');
        noticeEl.className = 'cart-item__notice';
        noticeEl.setAttribute('role', 'status');
      }
      noticeEl.textContent = notice;
      // Siempre debajo de cantidad/precio, nunca al lado
      info.appendChild(noticeEl);
    } else if (noticeEl) {
      noticeEl.remove();
    }
  };

  const liveCountFromDom = () =>
    [...drawer.querySelectorAll('[data-chikas-qty]')].reduce(
      (sum, el) => sum + (Number(el.value) || 0),
      0
    );

  const discountApps = (cart) => {
    const list = [];
    (cart.cart_level_discount_applications || []).forEach((app) => list.push(app));
    (cart.discount_applications || []).forEach((app) => {
      const same = list.some(
        (known) => known.title === app.title && known.total_allocated_amount === app.total_allocated_amount
      );
      if (!same) list.push(app);
    });
    return list;
  };

  const syncWholesale = (cart) => {
    const box = drawer.querySelector('[data-chikas-cart-wholesale]');
    if (!box || !cart) return;
    const original = Number(cart.original_total_price) || 0;
    const finalPrice = Number(cart.total_price) || 0;
    const off = Math.max(0, Number(cart.total_discount) || original - finalPrice);
    const count = Number(cart.item_count) || 0;
    const show = off > 0 && count >= 6;
    box.hidden = !show;
    if (!show) return;
    const apps = discountApps(cart);
    const app = apps.find((entry) => /mayor/i.test(String(entry.title || ''))) || apps[0];
    let label = 'Descuento mayorista';
    if (app && app.value_type === 'percentage' && app.value != null && String(app.value) !== '') {
      const pct = String(app.value).replace(/\.0+$/, '');
      label = `Descuento mayorista (−${pct}%)`;
    }
    const sub = box.querySelector('[data-chikas-cart-subtotal]');
    const offEl = box.querySelector('[data-chikas-cart-off]');
    const labelEl = box.querySelector('[data-chikas-cart-off-label]');
    if (sub) sub.textContent = formatMoney(original || finalPrice + off);
    if (offEl) offEl.textContent = `−${formatMoney(off)}`;
    if (labelEl) labelEl.textContent = label;
  };

  const updateTotalFromDom = () => {
    const totalEl = drawer.querySelector('[data-chikas-cart-total]');
    if (!totalEl) return;
    let sum = 0;
    drawer.querySelectorAll('.cart-item').forEach((row) => {
      const qty = Number(row.querySelector('[data-chikas-qty]')?.value || 0);
      const unit = Number(row.dataset.unitCents || 0);
      sum += qty * unit;
    });
    const box = drawer.querySelector('[data-chikas-cart-wholesale]');
    if (box && !box.hidden) {
      const sub = box.querySelector('[data-chikas-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(sum);
    } else {
      totalEl.textContent = formatMoney(sum);
    }
    syncSavings();
  };

  const totalsHtml = (totalCents) => `
          <div class="chikas-drawer__breakdown" data-chikas-cart-wholesale hidden>
            <div class="chikas-drawer__break-row">
              <span>Subtotal</span>
              <span data-chikas-cart-subtotal></span>
            </div>
            <div class="chikas-drawer__break-row chikas-drawer__break-row--off">
              <span data-chikas-cart-off-label>Descuento mayorista</span>
              <strong data-chikas-cart-off></strong>
            </div>
            <p class="chikas-drawer__wholesale-note">Se aplica al llevar 6 o más prendas</p>
          </div>
          <div class="chikas-drawer__total-row">
            <span>Total</span>
            <strong data-chikas-cart-total>${formatMoney(totalCents || 0)}</strong>
          </div>`;

  const ensureFormShell = () => {
    const body = drawer.querySelector('[data-chikas-cart-body]');
    if (!body) return null;
    let list = body.querySelector('[data-chikas-cart-items]');
    if (list) return list;

    body.innerHTML = `
      <form action="${root}cart" method="post" id="CartDrawerForm" data-chikas-cart-form>
        <div class="chikas-drawer__items" data-chikas-cart-items></div>
        <div class="chikas-drawer__footer">
          ${totalsHtml(0)}
          <p class="chikas-drawer__savings" data-chikas-cart-savings hidden></p>
          <p class="drawer-note">Pago seguro con Shopify Checkout.</p>
          <button class="btn full chikas-drawer__checkout" type="submit" name="checkout">IR A PAGAR</button>
          <button type="button" class="chikas-drawer__clear" data-chikas-cart-clear>Vaciar bolsa</button>
          <button type="button" class="chikas-drawer__continue" data-chikas-cart-close>SEGUIR COMPRANDO</button>
        </div>
      </form>`;
    return body.querySelector('[data-chikas-cart-items]');
  };

  const retargetRow = (row, item) => {
    row.setAttribute('data-key', item.key);
    const input = row.querySelector('[data-chikas-qty]');
    if (input) input.setAttribute('data-key', item.key);
    const remove = row.querySelector('[data-chikas-cart-remove]');
    if (remove) remove.setAttribute('data-chikas-cart-remove', item.key);
  };

  const rowForItem = (list, item) => {
    const exact = list.querySelector(`.cart-item[data-key="${escKey(item.key)}"]`);
    if (exact) return exact;
    if (!item.variant_id) return null;
    const prefix = `${item.variant_id}:`;
    return (
      [...list.querySelectorAll('.cart-item')].find((row) =>
        String(row.getAttribute('data-key') || '').startsWith(prefix)
      ) || null
    );
  };

  const upsertItem = (item, opts = {}) => {
    if (!item || !item.key) return;
    const list = ensureFormShell();
    if (!list) return;

    let row = rowForItem(list, item);
    if (row && row.getAttribute('data-key') !== item.key) retargetRow(row, item);
    if (!row) {
      list.insertAdjacentHTML(
        'afterbegin',
        itemHtml(item, opts.highlight ? item.key : '', opts.notice || '')
      );
      row = list.querySelector(`.cart-item[data-key="${escKey(item.key)}"]`);
      if (row && opts.highlight) {
        window.setTimeout(() => row.classList.remove('is-just-added'), 1800);
      }
      syncLineDiscount(row);
      loadCompare(item);
      return row;
    }

    const input = row.querySelector('[data-chikas-qty]');
    const priceEl = row.querySelector('.cart-item__price');
    if (input) input.value = String(item.quantity);
    if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
    row.dataset.unitCents = String(item.final_price || 0);
    const ref = refCents(item);
    row.dataset.refCents = String(
      compareKnown[item.variant_id] === undefined ? Math.max(ref, Number(row.dataset.refCents || 0)) : ref
    );
    row.dataset.discountTitle = discountTitle(item);
    syncLineDiscount(row);
    loadCompare(item);
    if (opts.notice !== undefined) setLineNotice(row, opts.notice || '');
    if (opts.highlight) {
      row.classList.add('is-just-added');
      window.setTimeout(() => row.classList.remove('is-just-added'), 1800);
    }
    return row;
  };

  const patchCart = (cart, opts = {}) => {
    const body = drawer.querySelector('[data-chikas-cart-body]');
    const notices = opts.notices || {};
    const items = cart.items || [];

    if (!cart.item_count) {
      if (body) body.innerHTML = emptyHtml();
      setCount(0, { pulse: false });
      return;
    }

    const list = ensureFormShell();
    if (!list) {
      renderCart(cart, { quiet: true, ...opts });
      return;
    }

    items.forEach((item) => {
      upsertItem(item, {
        notice: notices[item.key] || '',
        highlight: opts.highlightKey === item.key,
      });
    });

    const serverKeys = new Set(items.map((i) => i.key));
    [...list.querySelectorAll('.cart-item')].forEach((row) => {
      const key = row.getAttribute('data-key');
      if (!serverKeys.has(key)) row.remove();
    });

    const total = drawer.querySelector('[data-chikas-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    syncWholesale(cart);
    syncSavings();
    setCount(cart.item_count || 0, { pulse: false });
  };

  const renderCart = (cart, opts = {}) => {
    const body = drawer.querySelector('[data-chikas-cart-body]');
    if (!body) return;
    setCount(cart.item_count || 0, { pulse: !opts.quiet });

    if (!cart.item_count) {
      body.innerHTML = emptyHtml();
      return;
    }

    // Preferir patch in-place para no recargar imágenes (sin flash de carga)
    if (body.querySelector('[data-chikas-cart-items]')) {
      patchCart(cart, opts);
      return;
    }

    const highlightKey = opts.highlightKey || '';
    const notices = opts.notices || {};
    const items = (cart.items || [])
      .map((item) => itemHtml(item, highlightKey, notices[item.key] || notices[String(item.variant_id)] || ''))
      .join('');

    body.innerHTML = `
      <form action="${root}cart" method="post" id="CartDrawerForm" data-chikas-cart-form>
        <div class="chikas-drawer__items" data-chikas-cart-items>${items}</div>
        <div class="chikas-drawer__footer">
          ${totalsHtml(cart.total_price)}
          <p class="chikas-drawer__savings" data-chikas-cart-savings hidden></p>
          <p class="drawer-note">Pago seguro con Shopify Checkout.</p>
          <button class="btn full chikas-drawer__checkout" type="submit" name="checkout">IR A PAGAR</button>
          <button type="button" class="chikas-drawer__clear" data-chikas-cart-clear>Vaciar bolsa</button>
          <button type="button" class="chikas-drawer__continue" data-chikas-cart-close>SEGUIR COMPRANDO</button>
        </div>
      </form>`;

    if (highlightKey) {
      const row = body.querySelector(`.cart-item[data-key="${escKey(highlightKey)}"]`);
      if (row) {
        window.setTimeout(() => row.classList.remove('is-just-added'), 1800);
      }
    }
    syncAllDiscounts();
    syncWholesale(cart);
    (cart.items || []).forEach(loadCompare);
  };

  const fetchCart = () =>
    fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' }).then((r) => {
      if (!r.ok) throw new Error('No se pudo cargar la bolsa');
      return r.json();
    });

  const refresh = (opts = {}) =>
    fetchCart().then((cart) => {
      renderCart(cart, opts);
      return cart;
    });

  const localizeAvailability = (msg, qty) => {
    const text = String(msg || '');
    const onlyMatch =
      text.match(/only\s+(\d+)\s+items?/i) ||
      text.match(/solo\s+se\s+a[nñ]ad(?:ieron|ió)\s+(\d+)/i) ||
      text.match(/solo\s+(\d+)\s+art[ií]culos?/i);
    const n = onlyMatch ? Number(onlyMatch[1]) : Number(qty) || 0;

    if (n > 0) {
      return `Debido a la disponibilidad, solo se añadieron ${n} ${n === 1 ? 'artículo' : 'artículos'} al carrito.`;
    }
    if (/sold out|agotad|no longer available|no hay|out of stock|inventory/i.test(text)) {
      return 'Esta talla no tiene más disponibilidad por ahora.';
    }
    if (/availability|disponib/i.test(text)) {
      return 'No hay más disponibilidad de esta talla por ahora.';
    }
    return text || 'No hay más disponibilidad por ahora.';
  };

  const isAvailabilityIssue = (msg) =>
    /availability|disponib|sold out|agotad|only\s+\d+\s+items|inventory|stock/i.test(String(msg || ''));

  const findRowByVariant = (id) => {
    const wanted = `${id}:`;
    return [...drawer.querySelectorAll('.cart-item')].find((row) =>
      String(row.getAttribute('data-key') || '').startsWith(wanted)
    );
  };

  const paintLine = (key, qty) => {
    const nextQty = Math.max(0, Number(qty) || 0);
    const row = key ? drawer.querySelector(`.cart-item[data-key="${escKey(key)}"]`) : null;
    if (!row) return;
    const input = row.querySelector('[data-chikas-qty]');
    const priceEl = row.querySelector('.cart-item__price');
    const unitCents = Number(row.dataset.unitCents || 0);
    if (nextQty <= 0) {
      row.remove();
      const left = drawer.querySelectorAll('.cart-item').length;
      if (!left) {
        const body = drawer.querySelector('[data-chikas-cart-body]');
        if (body) body.innerHTML = emptyHtml();
        setCount(0, { pulse: false });
      } else {
        updateTotalFromDom();
        setCount(liveCountFromDom(), { pulse: false });
      }
      return;
    }
    if (input) input.value = String(nextQty);
    if (priceEl && unitCents > 0) priceEl.textContent = formatMoney(unitCents * nextQty);
    syncLineDiscount(row);
    updateTotalFromDom();
    setCount(liveCountFromDom(), { pulse: false });
  };

  const lineWant = (value) =>
    value && typeof value === 'object'
      ? { qty: Math.max(0, Number(value.qty) || 0), key: String(value.key || '') }
      : { qty: Math.max(0, Number(value) || 0), key: '' };

  const reapplyLocal = () => {
    desiredByVariant.forEach((value, variantId) => {
      const want = lineWant(value);
      const row = findRowByVariant(variantId);
      if (row) paintLine(row.getAttribute('data-key'), want.qty);
    });
    pendingAdds.forEach((extra, id) => {
      const row = findRowByVariant(id);
      if (!row) return;
      const key = row.getAttribute('data-key');
      const variantId = String(key).split(':')[0];
      if (desiredByVariant.has(variantId)) return;
      const input = row.querySelector('[data-chikas-qty]');
      paintLine(key, Number(input?.value || 0) + extra);
    });
  };

  const commitCart = (cart, opts) => {
    if (!cart) return;
    patchCart(cart, opts);
    reapplyLocal();
  };

  const workLeft = () =>
    clearQueued || desiredByVariant.size > 0 || pendingAdds.size > 0 || refreshQueued;

  const commitIfCurrent = (cart, opts) => {
    if (clearQueued || !cart) return;
    commitCart(cart, opts);
  };

  const kick = () => {
    if (pumping) return;
    pumping = true;
    pump()
      .catch((err) => {
        console.error(err);
        showStatus(err.message || 'Error al actualizar');
      })
      .finally(() => {
        pumping = false;
        if (workLeft()) kick();
      });
  };

  const pump = async () => {
    let lineRetries = 0;
    while (workLeft()) {
      if (clearQueued) {
        clearQueued = false;
        desiredByVariant.clear();
        pendingAdds.clear();
        refreshQueued = false;
        let cleared = null;
        try {
          const res = await fetch(`${root}cart/clear.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          cleared = await res.json().catch(() => null);
          if (!res.ok) throw new Error('clear');
        } catch (err) {
          if (!clearQueued) {
            const cart = await fetchCart().catch(() => null);
            if (cart) commitCart(cart);
            showStatus('No se pudo vaciar la bolsa');
          }
          continue;
        }
        if (!clearQueued) {
          commitCart(
            cleared && Array.isArray(cleared.items)
              ? cleared
              : { item_count: 0, items: [], total_price: 0, total_discount: 0 }
          );
          showStatus('Bolsa vaciada');
        }
        continue;
      }

      if (desiredByVariant.size) {
        const [variantId, raw] = desiredByVariant.entries().next().value;
        const want = lineWant(raw);
        desiredByVariant.delete(variantId);
        const row = findRowByVariant(variantId);
        const key = (row && row.getAttribute('data-key')) || want.key;
        if (!key) {
          refreshQueued = true;
          continue;
        }
        let res;
        let data = {};
        try {
          res = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: want.qty }),
          });
          data = await res.json();
        } catch (err) {
          if (!clearQueued) {
            refreshQueued = true;
            showStatus('Error al actualizar');
          }
          break;
        }
        if (clearQueued) continue;
        const msg = data.description || data.message || '';
        if (!res.ok) {
          const invalidLine = /inv[aá]lid|lineal|line item|line parameter/i.test(msg);
          if (invalidLine && lineRetries < 2) {
            lineRetries += 1;
            const cart = await fetchCart().catch(() => null);
            const fresh =
              cart && (cart.items || []).find((item) => String(item.variant_id) === String(variantId));
            if (!desiredByVariant.has(variantId)) {
              desiredByVariant.set(variantId, { qty: want.qty, key: (fresh && fresh.key) || key });
            }
            if (cart) commitIfCurrent(cart);
            continue;
          }
          lineRetries = 0;
          const cart = data.items ? data : await fetchCart().catch(() => null);
          const notices = {};
          if (isAvailabilityIssue(msg)) {
            notices[key] = localizeAvailability(msg, want.qty);
            if (cart) commitIfCurrent(cart, { notices });
            showStatus('Disponibilidad limitada');
          } else {
            if (cart) commitIfCurrent(cart);
            showStatus(msg || 'No se pudo actualizar');
          }
          continue;
        }
        lineRetries = 0;
        commitIfCurrent(data);
        continue;
      }

      if (pendingAdds.size) {
        const [id, qty] = pendingAdds.entries().next().value;
        pendingAdds.delete(id);
        let res;
        let added = {};
        try {
          res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
          });
          added = await res.json().catch(() => ({}));
        } catch (err) {
          refreshQueued = true;
          showStatus('No se pudo agregar');
          break;
        }
        const serverMsg = added.description || added.message || '';
        if (!res.ok) {
          const cart = await fetchCart().catch(() => null);
          const key =
            added.key ||
            (cart && cart.items && cart.items[0] && cart.items[0].key) ||
            '';
          if (clearQueued) continue;
          if (key && isAvailabilityIssue(serverMsg)) {
            const notices = {};
            notices[key] = localizeAvailability(serverMsg, added.quantity || qty);
            if (cart) commitIfCurrent(cart, { highlightKey: key, notices });
            showStatus('Disponibilidad limitada');
          } else {
            if (cart) commitIfCurrent(cart);
            showStatus(localizeAvailability(serverMsg) || 'No se pudo agregar');
          }
          continue;
        }
        if (clearQueued) continue;
        const notices = {};
        if (Number(added.quantity) > 0 && Number(added.quantity) < qty) {
          notices[added.key] = localizeAvailability(
            `Only ${added.quantity} items were added to your cart due to availability.`,
            added.quantity
          );
        }
        const cart = await fetchCart().catch(() => null);
        if (cart) commitIfCurrent(cart, { highlightKey: added.key, notices });
        else if (!clearQueued && added.key) upsertItem(added, { highlight: true, notice: notices[added.key] || '' });
        if (added.key && !clearQueued) showToast(added);
        if (notices[added.key]) showStatus('Disponibilidad limitada');
        continue;
      }

      if (refreshQueued) {
        refreshQueued = false;
        if (clearQueued) continue;
        const cart = await fetchCart().catch(() => null);
        if (cart) commitIfCurrent(cart);
      }
    }
  };

  const changeQty = (key, qty) => {
    const nextQty = Math.max(0, Number(qty) || 0);
    const variantId = String(key).split(':')[0];
    const row = findRowByVariant(variantId);
    const liveKey = (row && row.getAttribute('data-key')) || key;
    desiredByVariant.set(variantId, { qty: nextQty, key: liveKey });
    paintLine(liveKey, nextQty);
    kick();
  };

  const clearCart = () => {
    clearQueued = true;
    desiredByVariant.clear();
    pendingAdds.clear();
    refreshQueued = false;
    const body = drawer.querySelector('[data-chikas-cart-body]');
    if (body) body.innerHTML = emptyHtml();
    setCount(0, { pulse: false });
    showStatus('Bolsa vaciada');
    kick();
  };

  const addFromForm = (form) => {
    const fd = new FormData(form);
    const id = fd.get('id');
    const requested = Math.max(1, Number(fd.get('quantity') || 1));
    if (!id) return Promise.resolve();
    pendingAdds.set(String(id), (pendingAdds.get(String(id)) || 0) + requested);
    const row = findRowByVariant(id);
    if (row) {
      const input = row.querySelector('[data-chikas-qty]');
      paintLine(row.getAttribute('data-key'), Number(input?.value || 0) + requested);
    }
    pulseBag();
    open();
    showStatus('Añadido a tu bolsa');
    kick();
    return Promise.resolve();
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-chikas-cart-open]')) {
      e.preventDefault();
      hideToast();
      open();
      refreshQueued = true;
      kick();
      return;
    }

    if (e.target.closest('[data-chikas-cart-clear]')) {
      e.preventDefault();
      clearCart();
      return;
    }

    if (e.target.closest('[data-chikas-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }

    const removeBtn = e.target.closest('[data-chikas-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeQty(removeBtn.getAttribute('data-chikas-cart-remove'), 0);
      return;
    }

    const minus = e.target.closest('[data-chikas-qty-minus]');
    const plus = e.target.closest('[data-chikas-qty-plus]');
    if (minus || plus) {
      e.preventDefault();
      const wrap = e.target.closest('.cart-item');
      const input = wrap && wrap.querySelector('[data-chikas-qty]');
      if (!input) return;
      const next = Math.max(0, Number(input.value || 0) + (plus ? 1 : -1));
      changeQty(input.dataset.key, next);
      return;
    }

    const a = e.target.closest('a[href]');
    if (!a) return;
    try {
      const url = new URL(a.href, window.location.origin);
      const isCart =
        url.pathname.replace(/\/$/, '') === `${root.replace(/\/$/, '')}/cart` ||
        url.pathname.replace(/\/$/, '') === '/cart';
      if (isCart && !a.hasAttribute('data-chikas-full-cart') && !a.closest('[data-chikas-cart-form]')) {
        e.preventDefault();
        open();
        refreshQueued = true;
        kick();
      }
    } catch (_) {
      /* ignore */
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) close();
  });

  drawer.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.open) {
      e.preventDefault();
      close();
    }
  });

  syncAllDiscounts();

  if (document.body.classList.contains('template-cart')) {
    refresh().finally(open);
  }
})();
